import type { ListChannelsResponse } from '@nadoutong/contracts';
import { platformApiRequest } from './client.ts';

export async function listChannels(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<ListChannelsResponse> {
  return platformApiRequest<ListChannelsResponse>('/v1/channels', { signal }, fetchImpl);
}
